module.exports = __webpack_public_path__ + "static/brewery-bg-short2-9a18cf50688948139b8014df46510de2.jpg";